const SHOP_DOMAIN = 'goairshop.myshopify.com'
const PLATFORM = 'shopify'
const ENDPOINT = 'https://judge.me/api/v1/reviews'

export const submitReviewUtil = async ({
  reviewerName,
  reviewerEmail,
  rating,
  title,
  body,
  productId
}) => {
  const formData = new FormData()
  formData.append('shop_domain', SHOP_DOMAIN)
  formData.append('platform', PLATFORM)
  formData.append('name', reviewerName)
  formData.append('email', reviewerEmail)
  formData.append('rating', rating)
  formData.append('title', title)
  formData.append('body', body)
  formData.append('id', productId)

  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      Accept: '*/*',
      Origin: 'https://goairshop.com',
      Referer: 'https://goairshop.com/'
    },
    body: formData
  })

  const data = await response.json()

  if (!response.ok) {
    throw new Error('Failed to submit review')
  }

  return data
}
